import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

export interface ConfirmDialogData
{
  title: string;
  message: string;
  list?: string[];
}
@Component({
    selector: 'unite-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ConfirmDialogComponent {

  data: ConfirmDialogData;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: ConfirmDialogData) { 
    this.data = dialogData;
  }


}
